import {Component} from "preact";
import {newDate} from "../../../../utilities/date";
import dayjs from "dayjs";
import ConfigService from "../../../../services/ConfigService";

export default class CustomDate extends Component {
    static defaultProps = {
        date: null,
        format: 'YYYY-MM-DD HH:mm'
    };

    render(props, state, context) {
        if (!props.date) return null;

        const date = dayjs(newDate(props.date)).locale(ConfigService.currentLanguage());

        const format = 'YYYY-MM-DD HH:mm';
        const dateString = date.format(format);
        let displayDateString = date.format(props.format);

        return (
            <span title={dateString}>
                {displayDateString}
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./components/common/date/custom-date/index.js